import { InputProps } from "./input.types";

export const Input = ({
  error,
  label,
  showLabel = true,
  disable,
  ...props
}: InputProps) => {
  return (
    <>
      {showLabel && (
        <label
          className={`block text-sm font-medium leading-6 text-gray-900 ${
            disable && "text-gray-300"
          }`}
        >
          {label}
        </label>
      )}

      <div className="mt-1">
        <input
          {...props}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 px-3 disabled:ring-gray-100 disabled:bg-white"
          disabled={disable}
        />
        {error && (
          <p className="mt-2 text-sm text-red-600 dark:text-red-500">{error}</p>
        )}
      </div>
    </>
  );
};
